import { atom } from 'jotai';
import { store } from '.';

export const loadingInspectionMessageAtom = atom<{
  msg?: string | null;
  isLoadingProgress: boolean;
  backgroundSyncError?: string | null;
}>({ isLoadingProgress: false, msg: null, backgroundSyncError: null });

const InspectionProgressMessage = {
  set: (progress: {
    msg?: string | null;
    isLoadingProgress?: boolean | null;
    backgroundSyncError?: string | null;
  }) => {
    const queue = store.get(loadingInspectionMessageAtom);
    queue.isLoadingProgress =
      progress.isLoadingProgress ?? queue.isLoadingProgress;
    queue.msg = progress.msg;
    if (progress.backgroundSyncError !== undefined) {
      queue.backgroundSyncError = progress.backgroundSyncError;
    }
    store.set(loadingInspectionMessageAtom, { ...queue });
  },

  get: () => store.get(loadingInspectionMessageAtom),
};

export default InspectionProgressMessage;
